import useTranslation from 'hooks/useTranslation'
import Skeleton from 'react-loading-skeleton'

const Receipt = ({ data, independent = false, editAction }) => {
  const { id, name, pesel, street, building_nr, apartment_nr, zip_code, city, phone = '', email } = data || {}
  const { t } = useTranslation('form')

  const element = <div>
    <div className='list__header element__title'>{t('contractData')}</div>
    <div className='list__element --big'>
      {id ?
        <div className='element__title'>
          <div>{name}</div>
          <div>PESEL: {pesel}</div>
        </div>
        : <Skeleton />}

      {id ?
        <div className='group'>
          <div className='element__desc'>
            <div>{street} {building_nr}{apartment_nr ? `/${apartment_nr}` : ''}</div>
            <div>{zip_code} {city}</div>
            <div>tel. {phone?.replace(/(\d{3})/g, '$1 ')}</div>
            <div>email: {email}</div>
          </div>
          {editAction && <p
            className='element__edit'
            onClick={editAction}>
            {t('edit')}
          </p>}
        </div>
        : <Skeleton
          count={4}
          containerClassName='skeleton__desc' />}
    </div>
  </div>

  return (
    independent
      ? element
      : <div className='billing__receipt summary'>
        <div className='list'>
          {element}
        </div>
      </div>
  )
}

export default Receipt